import PropTypes from "prop-types";
import BasicInput from "../../reusable/input/BasicInput";
import Button from "../../reusable/Button";
import { object, string } from "yup";
import { useState } from "react";

function PersonalInfo({ handleChange, updateError, error, next }) {
  const [input, setInput] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
  });

  /* eslint-disable no-useless-escape */

  let personalInfoSchema = object({
    first_name: string()
      .required("must enter first name")
      .min(2, "first name must be at least 2 characters"),
    last_name: string()
      .required("must enter last name")
      .min(2, "last name must be at least 2 characters"),
    email: string()
      .required("must enter email")
      .email("must enter valid email"),
    password: string()
      .required("must enter password")
      .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.)/, "Password must have uppercase, lowercase, number, and special character")
      .min(8, "password must be at least 8 characters"),
  });

  const updateState = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
    handleChange(e);
  };

  async function savePersonalInfo(e) {
    e.preventDefault();
    personalInfoSchema
      .validate(input)
      .then(() => {
        updateError({});
        next();
      })
      .catch((err) => {
        updateError({ name: err.path, message: err.message });
      });
  }

  return (
    <form autoComplete="on">
      <BasicInput
        name="first_name"
        label="First name"
        placeholder="Input First Name"
        type="text"
        onChange={updateState}
        error={error}
      />
      <BasicInput
        name="last_name"
        label="Last name"
        placeholder="Input Last Name"
        type="text"
        onChange={updateState}
        error={error}
      />
      <BasicInput
        name="email"
        label="Email"
        placeholder="Input Email"
        type="email"
        onChange={updateState}
        error={error}
      />
      <BasicInput
        name="password"
        label="Password"
        placeholder="Input Password"
        type="password"
        onChange={updateState}
        error={error}
      />
      <div onClick={savePersonalInfo} className="flex justify-center my-8">
        <Button text="Save personal info" />
      </div>
    </form>
  );
}

PersonalInfo.propTypes = {
  handleChange: PropTypes.func,
  next: PropTypes.func,
  updateError: PropTypes.func,
  error: PropTypes.object,
};

export default PersonalInfo;
